/**
 * The SI's "Listening to ..." chip on its tile. The accent is the organization's own brand colour from its theme
 * (`--color-primary`, injected by branding/overrides.js from the org's globals.css), never a fixed blue; a neutral
 * slate otherwise. Every animation and transition stops under prefers-reduced-motion.
 */
export const SI_LISTENING_CSS = `
.ksl-chip {
  --ksl-accent: var(--color-primary, #5b6577);
  --ksl-accent-soft: color-mix(in srgb, var(--ksl-accent) 30%, transparent);
  position: absolute;
  left: 50%;
  top: 10px;
  z-index: 6;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100% - 20px);
  padding: 4px 12px 4px 6px;
  border-radius: 999px;
  color: #f8fafc;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1;
  white-space: nowrap;
  background: linear-gradient(135deg, rgba(17, 20, 27, 0.86), rgba(17, 20, 27, 0.72));
  -webkit-backdrop-filter: blur(14px) saturate(150%);
  backdrop-filter: blur(14px) saturate(150%);
  border: 1px solid color-mix(in srgb, var(--ksl-accent) 55%, rgba(255, 255, 255, 0.12));
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.38), 0 0 0 3px var(--ksl-accent-soft);
  transform: translateX(-50%);
  animation: ksl-in 320ms cubic-bezier(0.2, 0.9, 0.25, 1.2) both;
  pointer-events: auto;
}
.ksl-wave { display: inline-flex; align-items: flex-end; gap: 2px; height: 12px; padding-left: 4px; }
.ksl-wave i { width: 3px; border-radius: 2px; background: var(--ksl-accent); animation: ksl-wave 1.1s ease-in-out infinite; }
.ksl-wave i:nth-child(1) { height: 5px; animation-delay: -0.3s; }
.ksl-wave i:nth-child(2) { height: 11px; animation-delay: -0.15s; }
.ksl-wave i:nth-child(3) { height: 7px; }
.ksl-faces { display: inline-flex; align-items: center; }
.ksl-face {
  display: inline-flex;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(17, 20, 27, 0.95), 0 0 0 3.5px var(--ksl-accent);
  animation: ksl-pop 260ms cubic-bezier(0.2, 0.9, 0.25, 1.3) both;
}
.ksl-face + .ksl-face { margin-left: -6px; }
.ksl-more {
  margin-left: -4px;
  min-width: 22px;
  height: 22px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-size: 11px;
  background: var(--ksl-accent);
  color: #fff;
  box-shadow: 0 0 0 2px rgba(17, 20, 27, 0.95);
}
.ksl-text { overflow: hidden; text-overflow: ellipsis; }
@keyframes ksl-in { from { opacity: 0; transform: translate(-50%, -6px) scale(0.92); } to { opacity: 1; transform: translateX(-50%); } }
@keyframes ksl-pop { from { opacity: 0; transform: scale(0.4); } to { opacity: 1; transform: none; } }
@keyframes ksl-wave { 0%, 100% { transform: scaleY(0.45); } 50% { transform: scaleY(1); } }
@media (max-width: 480px) {
  .ksl-chip { font-size: 11.5px; padding: 3px 10px 3px 5px; gap: 6px; }
}
@media (prefers-reduced-motion: reduce) {
  .ksl-chip, .ksl-face, .ksl-wave i { animation: none !important; }
}
`;
